
import { Action, createReducer, on } from '@ngrx/store';
import { EntityEtapasEmpresaAddFailure, EntityEtapasEmpresaAddRequest, EntityEtapasEmpresaAddSuccess, EntityEtapasEmpresaDeleteFailure, EntityEtapasEmpresaDeleteRequest, EntityEtapasEmpresaDeleteSuccess, EntityEtapasEmpresaLoadFailure, EntityEtapasEmpresaLoadRequest, EntityEtapasEmpresaLoadSuccess, EntityEtapasEmpresaUpdateFailure, EntityEtapasEmpresaUpdateRequest, EntityEtapasEmpresaUpdateSuccess } from './entity-etapas-empresa.actions';
import { EntityEtapasEmpresaState, EntityEtapasEmpresaAdapter, initialState } from './entity-etapas-empresa.state';

const reducer = createReducer(
  initialState,
  on(EntityEtapasEmpresaLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEtapasEmpresaAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEtapasEmpresaUpdateRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEtapasEmpresaDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEtapasEmpresaLoadSuccess, (state, { items }) =>
    EntityEtapasEmpresaAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  on(EntityEtapasEmpresaLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),
  on(EntityEtapasEmpresaAddSuccess, (state, { item }) => {
    return EntityEtapasEmpresaAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    });
  }),
  on(EntityEtapasEmpresaUpdateSuccess, (state, { item }) => {
    return EntityEtapasEmpresaAdapter.upsertOne(item, {
      ...state,
      isLoading: false,
      error: null
    });
  }),
  on(EntityEtapasEmpresaDeleteSuccess, (state, { item }) => {
    return EntityEtapasEmpresaAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
    });
  }),
  on(EntityEtapasEmpresaAddFailure, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityEtapasEmpresaDeleteFailure, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityEtapasEmpresaUpdateFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),
);

export function EntityEtapasEmpresaReducer(
  state: EntityEtapasEmpresaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
